export const SET_PORTAL_API = 'SET_PORTAL_API';
export const RESET_PORTAL = 'RESET_PORTAL';
export const SET_PORTAL_OVERLAY = 'SET_PORTAL_OVERLAY';
export const SET_PORTAL_SLIDESHOW = 'SET_PORTAL_SLIDESHOW';
export const INCREMENT_SLIDE = 'INCREMENT_SLIDE';
export const DECREMENT_SLIDE = 'DECREMENT_SLIDE';
